import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=0e33b1b0"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuCategoryListPlain: require('/opt/build/repo/components/menu/category/ListPlain.vue').default})
